import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'
import log from 'loglevel'
import cx from 'classnames'

import config from '../../../../config'

import hocConnect from './hocConnect'
import hocDialog from '../../../../services/dialog/hocDialog'

import Logo from './components/Logo'
import Version from './components/Version'
import LogoutButton from './components/LogoutButton'
import DropDownMenu from './components/DropDownMenu'

import './style.scss'

const languagePrefix = 'scenes.Gnosus.components.MainMenu.language'
const settingsPrefix = 'scenes.Gnosus.components.MainMenu.settings'

@hocConnect
@hocDialog
export default class MainMenu extends Component {
    static propTypes = {
        locale: PropTypes.string.isRequired,
        openDialog: PropTypes.func.isRequired,
        setLocaleAction: PropTypes.func.isRequired,
        username: PropTypes.string.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.locale !== nextProps.locale) return true
        if (this.props.username !== nextProps.username) return true

        return false
    }

    onChangeLanguageHandler = (newLocale) => {
        const { locale, setLocaleAction } = this.props

        if (locale !== newLocale) setLocaleAction(newLocale)
    }

    onAccountClick = () => {
        const { openDialog } = this.props

        openDialog('userProfile')
    }

    onHelpClick = () => {
        log.info('open help dialog')
    }

    // create language drop down items from config
    createLanguageItems = () =>
        _.map(config.languages, (language) => ({
            icon: language.fullKey,
            text: <FormattedMessage id={`${languagePrefix}.${language.fullKey}.text`} />,
            callback: {
                func: this.onChangeLanguageHandler,
                params: [language.key],
            },
        }))

    render() {
        const { locale, username } = this.props

        // hide by config
        if (!config.components.mainMenu.show) return null

        const settingsItems = [
            {
                icon: 'account',
                text: <FormattedMessage id={`${settingsPrefix}.account.text`} />,
                callback: {
                    func: this.onAccountClick,
                },
            },
            {
                icon: 'help',
                text: <FormattedMessage id={`${settingsPrefix}.help.text`} />,
                callback: {
                    func: this.onHelpClick,
                },
            },
        ]

        return (
            <div className={cx('main-menu', !config.components.mainMenu.show && 'hide')}>
                <div className={'main-menu__submenu main-menu__submenu--left'}>
                    <div className={'main-menu__item'}>
                        <Logo openDialog={this.props.openDialog} />
                    </div>
                    <div className={'main-menu__item'}>
                        <Version />
                    </div>
                </div>
                <div className={'main-menu__submenu main-menu__submenu--right'}>
                    <div className={'main-menu__item'}>
                        <DropDownMenu
                            name={'languages'}
                            text={
                                <FormattedMessage
                                    id={`${languagePrefix}.title`}
                                    values={{ language: _.upperCase(locale) }}
                                />
                            }
                            items={this.createLanguageItems()}
                        />
                    </div>
                    <div className={'main-menu__item'}>
                        <DropDownMenu name={'settings'} text={username} items={settingsItems} />
                    </div>
                    <div className={'main-menu__item'}>
                        <LogoutButton />
                    </div>
                </div>
            </div>
        )
    }
}
